import { render, staticRenderFns } from "./CommonParent.vue?vue&type=template&id=511b470e&"
import script from "./CommonParent.vue?vue&type=script&lang=js&"
export * from "./CommonParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports